<template>
  <Modal v-model="showModal" :scrollable="true" :mask-closable="false" :width="width" @on-cancel="closeModal">
    <p slot="header">
      <Icon type="md-create" />
      <span class="header-label">{{ title }}</span>
    </p>
    <div style="position: relative;">
      <Spin v-if="loadingStatus" fix />
      <Form ref="form" :label-width="140" :model="formFields" :rules="ruleValidate">
        <FormItem label="客户ID:" prop="clientId">
          <Input v-model="formFields.clientId" placeholder="请输入客户ID..." size="small" :disabled="formFields.id" />
        </FormItem>
        <FormItem label="访问令牌有效期(s):" prop="accessTokenValiditySeconds">
          <Input v-model="formFields.accessTokenValiditySeconds" placeholder="请输入访问令牌有效期..." size="small" number />
        </FormItem>
        <FormItem label="刷新令牌有效期(s):" prop="refreshTokenValiditySeconds">
          <Input v-model="formFields.refreshTokenValiditySeconds" placeholder="请输入刷新令牌有效期..." size="small" number />
        </FormItem>
        <FormItem label="客户端范围:" prop="scopes">
          <Input v-model="formFields.scopes" placeholder="请输入客户端范围..." size="small" />
        </FormItem>
        <FormItem label="客户资源:" prop="resourceIds">
          <Input v-model="formFields.resourceIds" placeholder="请输入客户资源ids..." size="small" />
        </FormItem>
        <FormItem label="令牌类型:" prop="authorizedGrantTypes">
          <Input v-model="formFields.authorizedGrantTypes" placeholder="请输入令牌类型..." size="small" />
        </FormItem>
        <FormItem label="回馈地址:" prop="registeredRedirectUri">
          <Input v-model="formFields.registeredRedirectUri" placeholder="请输入回馈地址..." size="small" />
        </FormItem>
        <FormItem label="客户权限:" prop="authorities">
          <Input v-model="formFields.authorities" placeholder="请输入客户权限..." size="small" />
        </FormItem>
        <FormItem label="附加信息:" prop="additionalInformation">
          <Input v-model="formFields.additionalInformation" placeholder="请输入附加信息..." size="small" />
        </FormItem>
        <FormItem label="附加信息:" prop="remarks">
          <Input v-model="formFields.remarks" placeholder="请输入备注信息..." size="small" />
        </FormItem>
        <!-- <FormItem label="是否启用:" prop="enable">
          <RadioGroup v-model="formFields.enable">
            <Radio>
              可见
            </Radio>
            <Radio>
              隐藏
            </Radio>
          </RadioGroup>
        </FormItem> -->
        <input v-model="formFields.id" type="hidden" name="id"></input>
      </Form>
    </div>
    <div slot="footer">
      <Button
        type="primary"
        :disabled="loadingStatus"
        size="small"
        icon="ios-checkmark-circle-outline"
        :loading="submit"
        @click="saveOrUpdate"
      >
        保存
      </Button>
    </div>
  </Modal>
</template>

<script>
import request from '@/utils/request'
export default {
  name: 'TokenClientDialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    caption: {
      type: String,
      default: ''
    },
    width: {
      type: Number,
      default: 500
    },
    action: {
      type: String,
      default: ''
    },
    id: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      loadingStatus: false,
      modal: true,
      submit: false,
      formFields: {
        clientId: '',
        accessTokenValiditySeconds: 18000,
        refreshTokenValiditySeconds: 50000,
        scopes: 'read,write',
        clientSecret: '',
        autoApprove: 1,
        resourceIds: '',
        remarks: '',
        enable: true,
        authorizedGrantTypes: 'password,authorization_code,refresh_token',
        registeredRedirectUri: '',
        authorities: '',
        additionalInformation: '',
        id: this.id
      },
      ruleValidate: {
        clientId: [
          { required: true, message: '客户ID不能为空!', trigger: 'blur' }
        ],
        accessTokenValiditySeconds: [
          { required: true, type: 'number', message: '访问令牌有效期不能为空!', trigger: 'blur' }
        ],
        refreshTokenValiditySeconds: [
          { required: true, type: 'number', message: '刷新令牌有效期不能为空!', trigger: 'blur' }
        ]
      }
    }
  },
  computed: {
    title() {
      if (this.caption) {
        return this.caption
      } else {
        return this.id ? '编辑客户令牌' : '添加新客户令牌'
      }
    },
    showModal: {
      get() { return this.visible },
      set(value) { }
    }
  },
  watch: {
    showModal(val) {
      this.resetForm()
      this.loadingStatus = false
      if (this.action && this.id) {
        this.loadingStatus = true
        request({
          url: this.action + '/' + this.id,
          method: 'get'
        }).then(res => {
          this.loadingStatus = false
          this.formFields = res.data
        }).catch(() => {
          // this.$Notice.error({
          //   title: '服务器数据请求失败',
          //   desc: '请求地址: ' + this.action + ', 错误信息: ' + error
          // })
          this.loadingStatus = false
        })
      }
    }
  },
  methods: {
    resetForm: function() {
      this.$refs.form.resetFields()
      this.formFields.id = 0
    },
    saveOrUpdate: function() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          if (this.action) {
            this.$refs.form.validate((valid) => {
              if (valid) {
                this.submit = true
                const isNew = this.formFields.id === 0
                request({
                  url: this.action + (isNew ? '' : ('/' + this.id)),
                  method: isNew ? 'POST' : 'PUT',
                  data: this.formFields
                }).then(res => {
                  this.loadingStatus = false
                  this.formFields = res.data
                  this.$Notice.success({
                    title: '令牌 `' + this.formFields.clientId + '` 保存成功!'
                  })
                  this.submit = false
                  this.closeModal(true)
                }).catch(() => {
                  // this.$Notice.error({
                  //   title: '服务器数据请求失败',
                  //   desc: '请求地址: ' + this.action + ', 错误信息: ' + error
                  // })
                  this.loadingStatus = false
                  this.submit = false
                })
              }
            })
          }
        }
      })
    },
    closeModal: function(changed = false) {
      this.$emit('on-close', changed)
    }
  }
}
</script>

